import React from 'react';

const SubTitle = (item, value) => {
  if (value) {
    return (
      <div className="service-subscription-item"><span>{item}:
        <div className="service-subscription-value service-subscription-strong">{value}</div></span>
      </div>
    )
  }
  return;
}

export default SubTitle ;



// WEBPACK FOOTER //
// ./src/components/MyServices/SubTitle.js